var _defs, _g, _g2, _g3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapStylizedSmoothedOpti(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2600,
    height: 2000,
    viewBox: "0 0 687.92 529.17",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient14734",
    gradientTransform: "scale(.070004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9dd3b9",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7474"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bc5626",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5169"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eeae2c",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3260"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdfad6",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3254"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#563128",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3236"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3724d",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3238",
    x1: 175.01,
    x2: 683.79,
    y1: 291.04,
    y2: 291.04,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3996",
    x1: 172.57,
    x2: 681.91,
    y1: 289.72,
    y2: 289.72,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4308",
    x1: 62.289,
    x2: 82.115,
    y1: 193.11,
    y2: 193.11,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3254"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4310",
    x1: 360.14,
    x2: 382.89,
    y1: 295.94,
    y2: 295.94,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3254"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4312",
    x1: 622.69,
    x2: 636.99,
    y1: 301.83,
    y2: 301.83,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3254"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5171",
    x1: 331.18,
    x2: 415.42,
    y1: 164.27,
    y2: 164.27,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient5169"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5173",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3260"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5266",
    gradientTransform: "matrix(1.0678 0 0 1.1199 -25.424 -19.775)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3260"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5268",
    x1: 331.18,
    x2: 415.42,
    y1: 164.27,
    y2: 164.27,
    gradientTransform: "matrix(1.0678 0 0 1.1199 -25.424 -19.775)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7474"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7492",
    x1: 632.39,
    x2: 664.15,
    y1: 227.21,
    y2: 227.21,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient14734"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient8297",
    gradientTransform: "matrix(1.0678 0 0 1.1199 227.39 192.32)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3260"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient8301",
    gradientTransform: "translate(252.82 212.09)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3260"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient8303",
    x1: 331.18,
    x2: 415.42,
    y1: 164.27,
    y2: 164.27,
    gradientTransform: "translate(252.82 212.09)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient5169"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient8358",
    gradientTransform: "matrix(1.0678 0 0 1.1199 -320.7 101.05)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3260"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient8360",
    x1: 331.18,
    x2: 415.42,
    y1: 164.27,
    y2: 164.27,
    gradientTransform: "matrix(1.0678 0 0 1.1199 -320.7 101.05)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7474"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient8362",
    gradientTransform: "translate(-295.28 120.83)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3260"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient8364",
    x1: 331.18,
    x2: 415.42,
    y1: 164.27,
    y2: 164.27,
    gradientTransform: "translate(-295.28 120.83)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient5169"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient14736",
    x1: 624.09,
    x2: 638.83,
    y1: 229.71,
    y2: 229.71,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7474"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient14768",
    x1: 624.09,
    x2: 638.83,
    y1: 229.71,
    y2: 229.71,
    gradientTransform: "translate(-258.58 192.5)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7474"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient14789",
    x1: 624.09,
    x2: 638.83,
    y1: 229.71,
    y2: 229.71,
    gradientTransform: "translate(-561.14 -116.32)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7474"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient17898",
    x1: 331.18,
    x2: 415.42,
    y1: 164.27,
    y2: 164.27,
    gradientTransform: "matrix(1.0678 0 0 1.1199 227.39 192.32)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7474"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1792",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient14734"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m588.21 244.03c-5.062-39.268-43.587 0.1053-61.225 2.7693-12.487 17.2 0.95269 44.747-28.139 49.425-24.747 20.543-71.678 14.507-83.252 48.16-5.6553 21.103 10.534 62.828-23.497 62.859-29.614 0.30728-48.601 33.158-78.738 30.068-22.411-6.484-11.623-33.679 7.3711-34.411 27.806-30.208-2.0202-68.605-22.016-93.704-21.236-30.691-42.341-61.486-62.366-92.987-3.4047-18.329-21.291-22.26-35.314-18.065 5.5534-30.966-34.916-47.938-30.217-77.892-20.407-23.085-15.308-55.475-14.693-82.682-1.0722-14.741-29.356-31.022-16.716-5.3379 1.8761 15.195-37.825-11.799-17.946 15.163 17.01 24.801 12.389 63.064-6.8704 83.535-26.896 0.12245-34.743-33.84-16.1-49.491-11.127-10.611-20.575 30.073-30.464 40.022-12.857 22.619-25.809 45.193-37.911 68.23 11.169 21.104 61.789-14.768 46.663 25.788-14.273 23.876-50.529 64.687-5.7126 78.675 21.329 3.3555 30.039-30.621 52.334-8.8057 19.887 15.583 40.679 25.919 43.329 50.88 26.722-6.612 18.47 33.287 43.455 35.918 14.178 32.626-26.491 58.012-37.192 86.219-5.5953 32.076 38.046 21.225 50.912 44.222 24.029 21.305 50.891-0.82251 68.237-18.084 10.996-26.016-34.319 8.9932-43.918-12.087-11.822-13.385-30.158-21.494-43.736-28.512 14.745-5.8532 17.802-6.7938 1.0689-12.093 6.1602-10.549 27.81-23.541 33.326-29.575 2.4691 21.893 17.957 43.471 43.144 45.673 22.45-9.7266 5.877 43.596 36.264 31.195 15.942-27.132 49.321-48.711 82.006-46.485 21.754 4.085-20.143 49.721 21.998 49.372 33.421 6.0202 51.475-29.357 71.216-49.619 23.628-14.345-11.79-45.77 9.2345-59.161-20.574-5.6544-48.863 33.25-68.843 2.8025-19.104-30.399 18.115-57.686 46.329-56.702 16.107-2.4417 27.12 25.27 29.954-0.16393 9.6191-11.159 20.792 23.313 19.503-4.4246-2.5502-21.698-4.7966-44.785 6.1696-62.024 16.081-8.3039 35.064-5.4365 52.351-8.6681z",
    fill: "url(#linearGradient14734)",
    stroke: "url(#linearGradient1792)",
    strokeWidth: 2.065
  }), /*#__PURE__*/React.createElement("path", {
    d: "m635.16 228.38c12.192 9.7576 27.235-9.2687 6.4762-0.39498l-3.2299 0.26735z",
    fill: "url(#linearGradient1792)",
    stroke: "url(#linearGradient7492)",
    strokeWidth: 5.365
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.765
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168.95 5.6847 4.8568 7.6233 4.1191 6.7012 4.4879 6.8856 4.7953 7.9307 10.082 15.247 8.5455 13.402 2.2132 3.0124 6.0864 10.082 6.3938 10.267 7.07 10.943 6.7626 10.451 1.8444 2.7665 1.9058 6.6397 1.0451 5.4101 0.55331 8.607-0.3074 7.6848-2.4591 23.177-2.2747 22.87-0.61479 8.9759 0.61479 7.3774 1.1681 5.656 2.8895 7.6848 1.7829 3.6272 6.7626 10.451 10.144 15.124 12.173 17.952 7.5619 11.374 8.8529 12.603 13.402 19.858 10.943 16.23 6.2708 9.1603 8.9759 13.341 8.484 12.419 7.6233 10.39 9.2218 13.956 6.2708 9.1603 3.8117 6.1479 3.6272 5.9634 4.0576 9.7751 6.8241 15.124 10.205 23.792 3.1969 7.2545 5.1027 12.542 4.4264 10.513 7.1315 15.554 4.4265 9.898 2.3362 5.9019 4.1806 6.3938 1.7214 2.3362",
    stroke: "#c3724d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.45 521.8-5.9019-5.9634-3.1354-4.4879-1.8444-2.7665-3.5658-6.3323-6.3938-14.816-7.1315-17.091-13.525-30.801-11.005-25.391-4.7338-11.189-9.3447-14.632-10.882-15.37-13.033-19.858-5.8405-8.607-10.574-15.431-10.636-15.8-6.8241-10.021-11.374-16.476-9.7136-14.447-10.513-15.493-7.4389-11.005-9.1603-13.525-8.0537-12.542-2.705-4.3035-3.5658-10.759-1.5984-9.5292 0.36887-8.6685 0.67627-4.4264 0.73774-3.0739 1.1066-14.386 1.414-14.324 0.79922-7.193 0.36887-8.4226 0.24592-7.316-0.92218-7.07-0.73774-3.7502-3.1969-7.4389-2.0288-4.365-10.697-16.661-9.3447-14.632-5.4716-8.73-8.8529-13.341-7.7463-12.603-9.1603-14.263-7.4389-11.435-4.4879-7.3159",
    stroke: "#c3724d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.45 521.86 5.6514-10.868 1.478-2.6953 5.0862-6.6077 5.6513-5.3905 6.912-4.4342 3.7386-2.0866 8.9987-4.4776 11.259-5.2166 11.781-6.4773 8.7813-4.9558 7.5641-4.3907 4.8689-2.5214 22.779-13.042 30.778-17.563 7.825-5.9122 8.3466-9.216 3.7386-6.999 2.7387-4.9123 1.9562-6.26 1.2607-3.7386 0.73903-5.8687 1.565-9.2595 1.9128-12.172 1.5215-11.042 2.0867-7.4772 2.1301-6.173 2.6083-5.8687 6.0426-9.9116 2.3475-2.9996 3.2169-4.0429 4.8254-5.0862 8.0423-6.6947 7.9119-5.434 5.4774-3.6082 4.7819-2.7387 9.0422-5.9556 17.823-11.346 11.216-7.3033 14.998-9.3899 10.303-6.6512 8.3031-5.3036 10.868-6.912 13.563-8.564 14.085-8.8683 8.6074-4.3472 13.737-5.434 14.041-5.2166 8.6509-4.1733 11.042-5.2166 3.869-2.0432 13.694-8.6944 6.8251-4.4341 14.215-10.738 15.476-12.129 3.2604-2.5214 4.608-4.4341 4.2168-4.5211 6.4338-9.1291 6.173-9.5204 9.6073-14.867 4.8254-7.3902 3.5212-5.6079 7.2598-10.998 4.7819-7.5206 5.3036-8.8683 5.347-9.1291 5.4775-10.911",
    stroke: "url(#linearGradient3996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.9 521.92 6.0864-11.865 8.1766-9.7751 4.365-3.6272 6.1478-4.0576 9.0988-4.4264 11.742-5.5946 8.484-4.1805 7.193-3.2584 16.476-9.1603 25.821-14.755 32.399-18.628 8.8529-5.8405 7.0086-5.9634 8.1152-8.6685 7.0086-7.3159 6.0249-8.484 4.5494-6.2708 4.5494-7.3774 4.0576-7.8693 3.5043-6.6397 3.8731-9.4677 3.8117-11.128 6.2708-19.858 3.8732-11.927 4.0576-7.5004 4.0576-5.5945 4.6724-5.656 8.7914-7.3774 11.804-7.7463 21.64-13.71 15.431-9.898 32.276-20.595 11.066-7.1315 11.865-7.1315 15.8-6.5782 14.755-5.4716 13.218-6.5167 7.2545-3.6272 10.021-5.7175 3.6272-2.2747 12.48-9.0374 20.165-15.37 3.5043-2.7051 3.4428-2.705 8.5455-8.3611 6.3323-8.0537 8.9759-13.402 8.607-13.71 8.0537-12.173 10.759-16.845 9.5907-15.001 8.73-15.739",
    stroke: "url(#linearGradient3238)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.1262 125.09c17.609 28.573 31.788-33.416 56.687-15.998 24.386 4.5388 40.289 21.69 54.38 40.246 5.9259 34.383 50.474 0.97574 63.516 25.658 11.597 22.474 15.083 49.62 8.6944 72.511-3.0972 29.015 13.663 56.195 36.656 72.911 28.31 9.4296 54.512 29.173 56.896 60.808 2.6119 25.106 24.721 45.423 16.345 71.989-0.58913 35.621 33.31 6.367 39.774-11.025 21.242-20.285 54.068-37.352 82.99-22.188 22.172 8.9031 42.968 42.609 65.382 20.171 17.009-25.765-10.347-51.301-35.647-53.905-16.644 6.4207-37.449 3.9671-28.17-18.606 0.75216-22.979 6.3071-47.43 34.612-46.548 22.867-15.172 57.633-18.897 72.155-42.134 8.8727-10.799-25.896-18.945-0.58877-26.208 22.374-13 50.721-14.095 75.914-22.738 24.581-0.90168 46.39-2.2741 71.262-6.0022",
    stroke: "#479cbe",
    strokeLinejoin: "round",
    strokeWidth: 3.465
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.93 389.66c2.9202 24.821 28.777 8.1607 40.82 4.0864",
    stroke: "#479cbe",
    strokeLinejoin: "round",
    strokeWidth: 3.465
  }), /*#__PURE__*/React.createElement("g", {
    strokeDasharray: "2.513, 5.026",
    strokeMiterlimit: 2.6,
    strokeWidth: 2.513
  }, /*#__PURE__*/React.createElement("path", {
    d: "m372.68 417.92c33.072-80.339-39.195-158.22 1.5448-243.97",
    stroke: "url(#linearGradient4310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m631.43 233.6c-23.419 48.717 17.009 93.214 0 137.72",
    stroke: "url(#linearGradient4312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.812 114.66c32.732 56.786-27.408 108.14 0.20145 158.15",
    stroke: "url(#linearGradient4308)"
  })))), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 329.06,
    y: 134.6,
    width: 88.235,
    height: 59.191,
    ry: 14.559,
    fill: "url(#linearGradient5266)",
    imageRendering: "auto",
    stroke: "url(#linearGradient5268)",
    strokeLinejoin: "round",
    strokeWidth: 3.5114
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 331.98,
    y: 137.85,
    width: 82.633,
    height: 52.851,
    ry: 11.463,
    fill: "url(#linearGradient5173)",
    imageRendering: "auto",
    stroke: "url(#linearGradient5171)",
    strokeLinejoin: "round",
    strokeWidth: 3.211
  })), /*#__PURE__*/React.createElement("text", {
    x: 372.37924,
    y: 158.32799,
    fill: "url(#linearGradient3254)",
    fontFamily: "Righteous",
    fontSize: "16.933px",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.213,
    "text-align": "center",
    textAnchor: "middle",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 372.37924,
    y: 158.32799,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Loop"), /*#__PURE__*/React.createElement("tspan", {
    x: 372.37924,
    y: 179.49461,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "360")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 581.88,
    y: 346.7,
    width: 88.235,
    height: 59.191,
    ry: 14.559,
    fill: "url(#linearGradient8297)",
    imageRendering: "auto",
    stroke: "url(#linearGradient17898)",
    strokeLinejoin: "round",
    strokeWidth: 3.5114
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 584.8,
    y: 349.94,
    width: 82.633,
    height: 52.851,
    ry: 11.463,
    fill: "url(#linearGradient8301)",
    imageRendering: "auto",
    stroke: "url(#linearGradient8303)",
    strokeLinejoin: "round",
    strokeWidth: 3.211
  })), /*#__PURE__*/React.createElement("text", {
    x: 626.78369,
    y: 370.42114,
    fill: "url(#linearGradient3254)",
    fontFamily: "Righteous",
    fontSize: "16.933px",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.213,
    "text-align": "center",
    textAnchor: "middle",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 626.78369,
    y: 370.42114,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Barton"), /*#__PURE__*/React.createElement("tspan", {
    x: 626.78369,
    y: 391.58777,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Springs")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.784,
    y: 255.43,
    width: 88.235,
    height: 59.191,
    ry: 14.559,
    fill: "url(#linearGradient8358)",
    imageRendering: "auto",
    stroke: "url(#linearGradient8360)",
    strokeLinejoin: "round",
    strokeWidth: 3.5114
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36.704,
    y: 258.67,
    width: 82.633,
    height: 52.851,
    ry: 11.463,
    fill: "url(#linearGradient8362)",
    imageRendering: "auto",
    stroke: "url(#linearGradient8364)",
    strokeLinejoin: "round",
    strokeWidth: 3.211
  })), /*#__PURE__*/React.createElement("text", {
    x: 77.102501,
    y: 279.68298,
    fill: "url(#linearGradient3254)",
    fontFamily: "Righteous",
    fontSize: "16.933px",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.213,
    "text-align": "center",
    textAnchor: "middle",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 77.102501,
    y: 279.68298,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Lost"), /*#__PURE__*/React.createElement("tspan", {
    x: 77.102501,
    y: 300.84961,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Creek"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#eeb02b",
    strokeWidth: 4.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 631.39,
    cy: 229.7,
    r: 7.3033,
    stroke: "url(#linearGradient14736)",
    strokeDasharray: "48.44319222,96.88590041"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.82,
    cy: 422.2,
    r: 7.3033,
    stroke: "url(#linearGradient14768)",
    strokeDasharray: "48.4432, 96.8859"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.251,
    cy: 113.37,
    r: 7.3033,
    stroke: "url(#linearGradient14789)",
    strokeDasharray: "48.4432, 96.8859"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapStylizedSmoothedOpti);
export default __webpack_public_path__ + "static/media/map_stylized_smoothed_opti.904abf15ea8811c4efd6e1c4b06a3045.svg";
export { ForwardRef as ReactComponent };